// extracted by mini-css-extract-plugin
export var notificationHost = "_gb-0";